import styled from '@emotion/styled/macro';
import rem from '../../../../utils/rem/rem';

export const SelectSpecContainer = styled.div`
  margin: 0 32px;
`;

export const TableRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${rem(16)};
  gap: ${rem(20)};
  padding-top: ${rem(16)};

  svg {
    font-size: 50px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: ${rem(16)};
`;


export const TableWrapper = styled.div`
  width: calc(50vw - 144px);
  flex-grow: 1;
`;

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: ${rem(16)} 24px;
  margin: ${rem(20)} 0 ${rem(30)} 0;
`;

export const RadioWrapper = styled.div`
  padding-bottom: ${rem(8)};
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  padding-top: ${rem(16)};
`;

export const DeleteButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    border: none;
    background-color: transparent;
    cursor: pointer;
    font-size: ${rem(28)};
    width: ${rem(44)};
    height: ${rem(44)};
    color: ${({ theme }) => theme.colors.gray600};
    &:focus {
      outline: none;
    }
    &:focus svg {
      ${({ theme }) => theme.states.focus};
    }
`;


export const DropdownContainer = styled.div`
  min-height: 80px;
  display: flex;
  flex-direction: column;
`;